// extracted by mini-css-extract-plugin
module.exports = {"title":"Faq_title__2ghSB","collapse":"Faq_collapse___mRxc"};